/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_Option_FreelanceInputs */

const en_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelance work`)
};

const ar_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمل حر`)
};

const bn_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রিল্যান্স কাজ`)
};

const de_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelance-Arbeit`)
};

const es_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo freelance`)
};

const fr_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mission freelance`)
};

const pt_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho freelance`)
};

const zh_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自由职业合作`)
};

const tr_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freelance iş`)
};

const ru_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фриланс`)
};

const pl_form_subject_option_freelance = /** @type {(inputs: Form_Subject_Option_FreelanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Praca freelance`)
};

/**
* | output |
* | --- |
* | "Freelance work" |
*
* @param {Form_Subject_Option_FreelanceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_option_freelance = /** @type {((inputs?: Form_Subject_Option_FreelanceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_Option_FreelanceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_option_freelance(inputs)
	if (locale === "bn") return bn_form_subject_option_freelance(inputs)
	if (locale === "de") return de_form_subject_option_freelance(inputs)
	if (locale === "es") return es_form_subject_option_freelance(inputs)
	if (locale === "fr") return fr_form_subject_option_freelance(inputs)
	if (locale === "pt") return pt_form_subject_option_freelance(inputs)
	if (locale === "zh") return zh_form_subject_option_freelance(inputs)
	if (locale === "tr") return tr_form_subject_option_freelance(inputs)
	if (locale === "ru") return ru_form_subject_option_freelance(inputs)
	if (locale === "pl") return pl_form_subject_option_freelance(inputs)
	return en_form_subject_option_freelance(inputs)
});